import { render, staticRenderFns } from "./VkLabel.vue?vue&type=template&id=a09b97b6&"
import script from "./VkLabel.vue?vue&type=script&lang=ts&"
export * from "./VkLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports